import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

export default function LogoutPage() {
  const { logout } = useAuth();

  useEffect(() => {
    logout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="auth-page">
      <div className="card">
        <h1>Signing out…</h1>
        <p className="muted">If you are not redirected, go back to the sign-in page.</p>
        <Link className="btn btn-secondary" to="/login">
          Back to sign in
        </Link>
      </div>
    </div>
  );
}

